import React from 'react';
import { HistoryAction } from '../history/historyManager';

interface PageContextType {
  objItems: any[];
  setObjItems?: (item: any) => void;
  addItem?: (item: any) => void;
  removeItem?: (item: any) => void;
  cropCadreImage: any;
  setCropCadreImage?: (item: any) => void;
  cropImage: any;
  setCropImage?: (item: any) => void;
  selectedItem: any;
  setSelectedItem?: (item: any) => void;
  selectedItemIsLock: boolean;
  setSelectedItemIsLock?: (item: any) => void;
  page: any;
  setPage?: (item: any) => void;
  pageSize: any;
  setPageSize?: (item: any) => void;
  pageColor: any;
  setPageColor?: (item: any) => void;
  zoomValue: any,
  setZoomValue?: (item: any) => void;
  /* MAPBOX ELEMENT */
  mapPosition: any,
  setMapPosition?: (item: any) => void;
  mapIndex: any,
  setMapIndex?: (item: any) => void;
  mapTaille: any,
  setMapTaille?: (item: any) => void;
  mapZoom: any,
  setMapZoom?: (item: any) => void;
  mapCenter: any,
  setMapCenter?: (item: any) => void;
  mapUrlStyle: any,
  setMapUrlStyle?: (item: any) => void;
  mapSources: any[];
  mapLayers: any[];
  mapListEtape: any[];
  mapListPoint: any[];
  mapListTrace: any[];
  addMapSource?: (item: any) => void;
  addMapLayer?: (item: any) => void;
  addMapListEtape?: (item: any) => void;
  addMapListPoint?: (items: any[]) => void;
  addMapListTrace?: (item: any) => void;
  setMapSources?: (item: any) => void;
  setMapLayers?: (item: any) => void;
  setMapListEtape?: (item: any) => void;
  setMapListPoint?: (item: any) => void;
  setMapListTrace?: (item: any) => void;
  removeMapSources?: (item: any) => void;
  removeMapLayers?: (item: any) => void;
  removeMapListEtape?: (item: any) => void;
  removeMapListPoint?: (item: any, recalItineraire : boolean) => void;
  removeMapListTrace?: (item: any, recalItineraire : boolean) => void;
  isDraggableMap?: boolean,
  setIsDraggableMap?: (item: any) => void;
  traceStyle: any;
  setTraceStyle?: (item: any) => void;
  traceLayout: any;
  setTraceLayout?: (item: any) => void;
  isMarqueurDepart?: boolean,
  setIsMarqueurDepart?: (item: any) => void;
  isMarqueurArrivee?: boolean,
  setIsMarqueurArrivee?: (item: any) => void;
  isMarqueurEtapes?: boolean,
  setIsMarqueurEtapes?: (item: any) => void;
  styleMarqueurDepart?: any,
  setStyleMarqueurDepart?: (item: any) => void;
  styleMarqueurArrivee?: any,
  setStyleMarqueurArrivee?: (item: any) => void;
  styleMarqueurEtapes?: any,
  setStyleMarqueurEtapes?: (item: any) => void;
  isAfficheNoms?: boolean,
  setIsAfficheNoms?: (item: any) => void;
  isAfficheNomsDefaut: boolean,
  setIsAfficheNomsDefaut?: (item: any) => void;
  imgUserList: any[];
  addImgUserList?: (item: any) => void;
  isOpenOpacity: boolean;
  setIsOpenOpacity?: (item: any) => void;
  openAbsoluteMenuSection: string;
  setOpenAbsoluteMenuSection?: (item: any) => void;
  /* Non utilisé pr l'instant*/
  colorTextPicker: any,
  setColorTextPicker?: (item: any) => void;
  majDate: any,
  setMajDate?: (item: any) => void;
  modeAdmin: boolean,
  elevationData?: any,
  setElevationData?: (item: any) => void;
  chartRef: any,
  setChartRef?: (item: any) => void;
  isElevationPresent: boolean;
  setIsElevationPresent?: (item: any) => void;
  isMode3D: boolean;
  setIsMode3D?: (item: any) => void;
  initFondCarte: any,
  setInitFondCarte?: (item: any) => void;
  initModele: any,
  setInitModele?: (item: any) => void;
  addMapListTraceSpecialFirtstLoad?: (item: any, item2: any) => void;
  afficheType: any,
  setAfficheType?: (item: any) => void;
  isPortrait: boolean,
  setIsPortrait?: (item: any) => void;
  jsonFormat: any,
  setJsonFormat?: (item: any) => void;
  openAlertMsg: boolean,
  setOpenAlertMsg?: (item: any) => void;
  mapLock: boolean,
  setMapLock?: (item: any) => void;
  getMapListPoint?: () => void;
  getMapListTrace?: () => void;
  getSelectedItem?: () => void;

  history: {
    add(action: HistoryAction): void;
    undo(): void;
    redo(): void;
    canUndo: boolean;
    canRedo: boolean;
    clear(): void;
  };
}

const defaultState = {
  objItems: [],
  cropCadreImage: null,
  cropImage: null,
  selectedItem: null,
  selectedItemIsLock: false,
  page: null,
  pageSize: null,
  pageColor: null,
  zoomValue: null,
  mapPosition: null,
  mapIndex: null,
  mapTaille: null,
  mapZoom: null,
  mapCenter: null,
  mapUrlStyle: null,
  mapSources: new Array(),
  mapLayers: new Array(),
  mapListEtape: new Array(),
  mapListPoint: new Array(),
  mapListTrace: new Array(),
  isDraggableMap: false,
  colorTextPicker: null,
  traceStyle: null,
  traceLayout: null,
  imgUserList: new Array(),
  isOpenOpacity: false,
  openAbsoluteMenuSection: '',
  isMarqueurDepart: true,
  isMarqueurArrivee: true,
  isMarqueurEtapes: true,
  isAfficheNoms: false,
  isAfficheNomsDefaut: false,
  styleMarqueurDepart: null,
  styleMarqueurArrivee: null,
  styleMarqueurEtapes: null,
  majDate: null,
  modeAdmin: false,
  elevationData: null,
  chartRef: null,
  isElevationPresent: false,
  isMode3D: false,
  initFondCarte: null,
  initModele: null,
  afficheType: null,
  isPortrait: true,
  jsonFormat: null,
  openAlertMsg: false,
  mapLock: false,
  history: {
    add: () => { },
    undo: () => { },
    redo: () => { },
    clear: () => { },
    canUndo: false,
    canRedo: false,
  },
};

const PageContext = React.createContext<PageContextType>(defaultState);

export default PageContext;